
// import { setObj } from "@/utils/object-method";
import { MessagePlugin as Message } from 'tdesign-vue-next';
export default (props) => {
    const creatGrid = (datas,attr) => {
        if(attr.dataGroup){//是否数据分组
            creatByGroup(datas)
        }
        const BORDER_TYPES = {
            CHILD: 'ngcombination-border',
            FATHER: 'ngcombination'
        };
        const fatherBorder = Object.values(props.cacheChoices).find(x => x.cptType === BORDER_TYPES.FATHER);
        let findid = fatherBorder.group.find(x => fatherBorder.id !== x )
        const childBorder = Object.values(props.cacheComponents).find(x => x.id === findid);
        const isPop = fatherBorder.cptOption.attribute.isPop
        const colNum = isPop ? 1 : fatherBorder.cptOption.attribute.colNum;
        childBorder.cptOption.attribute.gridType = 'grid'
        let childListCpt = []
        childListCpt.push(childBorder)
        if(!(fatherBorder.tabGroup['index-0'] && fatherBorder.tabGroup['index-0'].length>0)){
            Message.error('请先拖入一个元素到九宫格内再点击生成！');
            return
        }
        for (let i = 0; i < fatherBorder.tabGroup['index-0']?.length; i++) {
            let proCpt = props.cacheComponents.find(comp => comp.id == fatherBorder.tabGroup['index-0'][i])
            if(proCpt){

                let ids = childListCpt.map(item=>item.id);
                if(!ids.includes(proCpt.id)){
                    childListCpt.push(proCpt)
                }else {
                    let index = ids.findIndex(item=>item == proCpt.id);
                    childListCpt[index] =proCpt
                }
                // childListCpt.push(proCpt)
            }
        }

        //清空复制出来的元素

        for (let i = fatherBorder.cptOption.copyItems.length - 1; i >= 0; i--) {
            let id = fatherBorder.cptOption.copyItems[i];
            let modifyCptIndex = props.cacheComponents.findIndex((item) => item.id === id);
            if (modifyCptIndex !== -1) {
                props.cacheComponents.splice(modifyCptIndex, 1);
            }
        }
        fatherBorder.cptOption.copyItems = []
        fatherBorder.tabGroup = {
            'index-0':fatherBorder.tabGroup["index-0"]
        }
        // 大div的宽度
        var bigDivWidth = fatherBorder.cptWidth;

        // 大div的横坐标
        var bigDivLeft = fatherBorder.cptX;

        // 大div的纵坐标
        var bigDivTop = fatherBorder.cptY;

        // 大div的左内边距
        var bigDivPaddingLeft = fatherBorder.cptOption.attribute.leftSpace;

        // 大div的右内边距
        var bigDivPaddingRight = fatherBorder.cptOption.attribute.rightSpace;

        // 大div的上内边距
        var bigDivPaddingTop = fatherBorder.cptOption.attribute.topSpace;

        // 小div的宽度
        var smallDivWidth = childBorder.cptWidth;

        // 小div的高度
        var smallDivHeight = childBorder.cptHeight;

        // 小div上下间距
        var smallDivMargin = fatherBorder.cptOption.attribute.gridSpace;

        // 小div的总数量
        var n = datas.length;

        // 每行的列数
        var m = colNum;


        // 计算小div之间的横向间距
        var spaceX = (bigDivWidth - m * smallDivWidth - bigDivPaddingLeft - bigDivPaddingRight) / (m - 1);

        // 小div的横坐标
        var cptX = childBorder.cptX;

        // 小div的纵坐标
        var cptY = childBorder.cptY;

        //计算每个元素与边框的距离
        var rList = []; 
        for (var j = 0; j < childListCpt.length; j++) {
            rList.push(
                {
                    marX:childListCpt[j].cptX - cptX,
                    marY:childListCpt[j].cptY - cptY,
                }
            )
        }

        // 计算每个小div的左边距和上边距并设置位置
        for (var i = 0; i < n; i++) {

            if(m == 1){ //单列就居中摆放
                // 计算小div的横向位置
                var smallDivLeft = bigDivLeft + (bigDivWidth - smallDivWidth) / 2;
                var smallDivTop = bigDivTop + bigDivPaddingTop + i * (smallDivHeight + smallDivMargin);

            }else{
                var smallDivLeft = bigDivLeft + bigDivPaddingLeft + (i % m) * (smallDivWidth + spaceX);
                var smallDivTop = bigDivTop + bigDivPaddingTop + Math.floor(i / m) * (smallDivHeight + smallDivMargin);
            }
            if(i == 0){
                childListCpt.forEach((item,index) => {
                    if (props.refMap && props.refMap[item.id] && typeof props.refMap[item.id].processData === 'function') {
                        if(props.refMap[item.id].option.cptDataForm && props.refMap[item.id].option.cptDataForm.dataSource == 4 && props.refMap[item.id].option.cptDataForm.datasetId){
                            props.refMap[item.id].processData(item.cptOption.cptDataForm, [datas[i]], true,'ninegrid');
                        }
                        
                      } else {
                        // 如果不存在该方法，则可以添加一个默认处理逻辑或者简单地忽略（根据你的需求）
                        console.warn(`processData method does not exist on refMap[${item.id}]`);
                      }
                    item.cptX = smallDivLeft + rList[index].marX
                    item.cptY = smallDivTop + rList[index].marY
                    item.cptOption.interaction.gridNumber = i
                    item.cptOption.interaction.fatherGridId = fatherBorder.id
                    item.cptOption.attribute.gridType = 'grid'
                    // item.cptShow = false

                })
            }else{
                props.pasteItemGrid(childListCpt,{smallDivLeft,smallDivTop},rList,fatherBorder,i,datas[i])
            }
            
        }

    }
    //分组
    const creatByGroup = (datas) => {
        //找到父边框
        const ngcombinationElements = Object.values(props.cacheChoices).filter(
            (x) => x.cptType === 'ngcombination'
        );
        let maxTabGroupLength = -1;
        let fatherBorder = null;

        ngcombinationElements.forEach((element) => {
            const tabGroupLength = element.tabGroup['index-0']?.length || 0;
          
            if (tabGroupLength > maxTabGroupLength) {
              maxTabGroupLength = tabGroupLength;
              fatherBorder = element;
            }
          });

        //找到子边框
        let findid = fatherBorder.group.find(x => fatherBorder.id !== x )
        const childBorder = Object.values(props.cacheChoices).find(x => x.id === findid);
        
        let nestNineGrid = ''//找到子九宫格父边框
        let nestNineChild = ''//找到子九宫格子边框
        fatherBorder.tabGroup['index-0'].forEach((id) => {
           let cpt = Object.values(props.cacheChoices).find(x => x.id === id)
           if(cpt && cpt.cptType == 'ngcombination'){
                nestNineGrid = cpt
           }else if(cpt && cpt.cptType == 'ngcombination-border'){
                nestNineChild = cpt
           }        
        })
        fatherBorder.nestNineChildId = nestNineChild.id
        fatherBorder.nestNineGrid = nestNineGrid.id
        props.refMap[nestNineChild.id].current.belongChildborder = true

        const filteredArray = fatherBorder.tabGroup['index-0'].filter((item) => {
            const cpt = Object.values(props.cacheChoices).find((x) => x.id === item);
            return !(cpt && (cpt.cptType === 'ngcombination' || cpt.cptType === 'ngcombination-border'));
          });
          
        const aboveBaseline = []; //位于子九宫格上方的元素
        const belowBaseline = []; //位于子九宫格下方的元素
        filteredArray.forEach((id) => {
            // 现在遍历的数组中已排除了 cpt.cptType 为 'ngcombination' 和 'ngcombination-border' 的元素
            const divElement = document.getElementById(id);

            if (!divElement) {
                console.warn(`Element with id ${id} not found.`);
                return;
            }
        
            const divRect = divElement.getBoundingClientRect();
            const baselineRect = document.getElementById(nestNineChild.id).getBoundingClientRect();
        
            if (divRect.bottom <= baselineRect.top) {
                aboveBaseline.push(id);
                props.refMap[id].current.gridposition = 'above'
            } else if (divRect.top >= baselineRect.bottom) {
                belowBaseline.push(id);
                props.refMap[id].current.gridposition = 'below'
            }else{
                props.refMap[id].current.belongChild = true
            }
        });
        console.log(aboveBaseline,'aboveBaseline')
        console.log(belowBaseline,'belowBaseline')


    }
    //动态生成
    const creatGridPreview  = (objs) => {
        let isDesign = location.href.includes("/design");
        console.log(objs,'objs')
        // const BORDER_TYPES = {
        //     CHILD: 'ngcombination-border',
        //     FATHER: 'ngcombination'
        // };
        console.log('wqerwerwer')
        let findid = objs.fatherGrid.group.find(x => objs.fatherGrid.id !== x )
        let childBorder = ''
        if(objs.refMap[findid]){
             childBorder = objs.refMap[findid].current
        }else{
             return
        }
        const fatherBorder = objs.fatherGrid
        childBorder.cptOption.attribute.gridType = 'grid'
        // fatherBorder.gridType = 'grid'
        const isPop = fatherBorder.cptOption.attribute.isPop
        const colNum = isPop ? 1 : fatherBorder.cptOption.attribute.colNum;
        let childListCpt = []
        childListCpt.push(childBorder)
        if(!(fatherBorder.tabGroup['index-0'] && fatherBorder.tabGroup['index-0'].length > 0)){
            Message.error('请先拖入一个元素到九宫格内再点击生成！');
            return
        }
        for (let i = 0; i < fatherBorder.tabGroup['index-0']?.length; i++) {
            if (Array.isArray(props.cacheComponents)) {
                let proCpt = props.cacheComponents.find(comp => comp.id == fatherBorder.tabGroup['index-0'][i])
                if(proCpt){

                    let ids = childListCpt.map(item=>item.id);
                    if(!ids.includes(proCpt.id)){
                        childListCpt.push(proCpt)
                    }else {
                        let index = ids.findIndex(item=>item == proCpt.id);
                        childListCpt[index] =proCpt
                    }
                    // childListCpt.push(proCpt)
                }
            }
        }

        //清空复制出来的元素
        // fatherBorder.cptOption.copyItems.forEach((id) => {
        //     let modifyCptIndex = props.cacheComponents.findIndex((item) => item.id === id)
        //     props.cacheComponents.splice(modifyCptIndex, 1)
        // })
        // fatherBorder.cptOption.copyItems = []


        for (let i = fatherBorder.cptOption.copyItems.length - 1; i >= 0; i--) {
            let id = fatherBorder.cptOption.copyItems[i];
            let modifyCptIndex;
            if(Array.isArray(props.cacheComponents)) { 
             modifyCptIndex =  props.cacheComponents.findIndex((item) => item.id === id)
            };
            if (modifyCptIndex !== -1) {
                if (Array.isArray(props.cacheComponents)) {props.cacheComponents.splice(modifyCptIndex, 1);} 
            }
        }
        fatherBorder.cptOption.copyItems = []

        fatherBorder.tabGroup = {
            'index-0':fatherBorder.tabGroup["index-0"]
        }
            
        
        
        // 大div的宽度
        var bigDivWidth = fatherBorder.cptWidth;

        // 大div的横坐标
        var bigDivLeft = fatherBorder.cptX;

        // 大div的纵坐标
        var bigDivTop = fatherBorder.cptY;

        // 大div的左内边距
        var bigDivPaddingLeft = fatherBorder.cptOption.attribute.leftSpace;

        // 大div的右内边距
        var bigDivPaddingRight = fatherBorder.cptOption.attribute.rightSpace;

        // 大div的上内边距
        var bigDivPaddingTop = fatherBorder.cptOption.attribute.topSpace;

        // 小div的宽度
        var smallDivWidth = childBorder.cptWidth;

        // 小div的高度
        var smallDivHeight = childBorder.cptHeight;

        // 小div上下间距
        var smallDivMargin = fatherBorder.cptOption.attribute.gridSpace;

        // 小div的总数量
        var n = objs.datas.length;

        // 每行的列数
        var m = colNum;


        // 计算小div之间的横向间距
        var spaceX = (bigDivWidth - m * smallDivWidth - bigDivPaddingLeft - bigDivPaddingRight) / (m - 1);

        // 小div的横坐标
        var cptX = childBorder.cptX;

        // 小div的纵坐标
        var cptY = childBorder.cptY;

        //计算每个元素与边框的距离
        var rList = []; 
        for (var j = 0; j < childListCpt.length; j++) {
            rList.push(
                {
                    // 修复加载更多功能添加后定位不准确
                    marX: !isDesign ? childListCpt[j].cptX - cptX - bigDivLeft : childListCpt[j].cptX - cptX,
                    marY: !isDesign ? childListCpt[j].cptY - cptY - bigDivTop : childListCpt[j].cptY - cptY ,
                }
            )
        }

        // 计算每个小div的左边距和上边距并设置位置
        for (var i = 0; i < n; i++) {

            if(m == 1){ //单列就居中摆放
                // 计算小div的横向位置
                var smallDivLeft = bigDivLeft + (bigDivWidth - smallDivWidth) / 2;
                var smallDivTop = bigDivTop + bigDivPaddingTop + i * (smallDivHeight + smallDivMargin);

            }else{
                var smallDivLeft = bigDivLeft + bigDivPaddingLeft + (i % m) * (smallDivWidth + spaceX);
                var smallDivTop = bigDivTop + bigDivPaddingTop + Math.floor(i / m) * (smallDivHeight + smallDivMargin);
            }
            if(i == 0){
                childListCpt.forEach((item,index) => {
                    if (props.refMap && props.refMap[item.id] && typeof props.refMap[item.id].processData === 'function') {
                        props.refMap[item.id].current.colData = objs.datas[i]
                        if(props.refMap[item.id].option.cptDataForm && props.refMap[item.id].option.cptDataForm.dataSource == 4 && props.refMap[item.id].option.cptDataForm.datasetId){
                            props.refMap[item.id].processData(item.cptOption.cptDataForm, [objs.datas[i]], true,'ninegrid');
                            
                        }
                        
                      } else {
                        // 如果不存在该方法，则可以添加一个默认处理逻辑或者简单地忽略（根据你的需求）
                        console.warn(`processData method does not exist on refMap[${item.id}]`);
                      }

                    item.cptX = smallDivLeft + rList[index].marX
                    item.cptY = smallDivTop + 0.1 + rList[index].marY
                    item.cptOption.interaction.gridNumber = i
                    item.cptOption.interaction.fatherGridId = fatherBorder.id
                    item.cptOption.attribute.gridType = 'grid'

                })
            }else{
                // props.pasteItemGrid(childListCpt,{smallDivLeft,smallDivTop},rList,fatherBorder,i,datas[i])
                objs.pasteItemGrid(childListCpt,{smallDivLeft,smallDivTop},rList,fatherBorder,i,objs.datas[i])
            }
            
        }

    }
    const conscale = (containerScale, type, val, str) => {
        // :style="{
        //     transform: 'translate3d(0,0,0) scale(' + 1/containerScale + ')',
        //     right:conscale(containerScale,'r',-32),
        //     top:conscale(containerScale,'t',4),
        //   }"

        // :style="{
        //     transform: 'translate3d(0,0,0) scale(' + 1/containerScale + ')',
        //     right:conscale(containerScale,'r',-171),
        //     top:conscale(containerScale,'t',86),
        //   }"
        if (str == '面板') {
            if (containerScale == 0.73) {
                if (type == 'r') {
                    return val+'px'
                }
                if (type == 't') {
                    return val+'px'
                }
            }else if (containerScale == 0.3) {
                if (type == 'r') {
                    return '-311px'
                }
                if (type == 't') {
                    return '403px'
                }
            }else if (containerScale == 0.4) {
                if (type == 'r') {
                    return '-250px'
                }
                if (type == 't') {
                    return '273px'
                }
            }else if (containerScale == 0.5) {
                if (type == 'r') {
                    return '-216px'
                }
                if (type == 't') {
                    return '189px'
                }
            }else if (containerScale == 0.6) {
                if (type == 'r') {
                    return '-192px'
                }
                if (type == 't') {
                    return '137px'
                }
            }else if (containerScale == 0.7) {
                if (type == 'r') {
                    return '-175px'
                }
                if (type == 't') {
                    return '97px'
                }
            } else if (containerScale == 0.8) {
                if (type == 'r') {
                    return '-162px'
                }
                if (type == 't') {
                    return '66px'
                }
            } else if (containerScale == 0.9) {
                if (type == 'r') {
                    return '-154px'
                }
                if (type == 't') {
                    return '45px'
                }
            } else if (containerScale == 1.0) {
                if (type == 'r') {
                    return '-145px'
                }
                if (type == 't') {
                    return '26px'
                }
            } else if (containerScale == 1.1) {
                if (type == 'r') {
                    return '-137px'
                }
                if (type == 't') {
                    return '13px'
                }
            } else if (containerScale == 1.2) {
                if (type == 'r') {
                    return '-133px'
                }
                if (type == 't') {
                    return '-1px'
                }
            } else if (containerScale == 1.3) {
                if (type == 'r') {
                    return '-128px'
                }
                if (type == 't') {
                    return '-11px'
                }
            } else if (containerScale == 1.4) {
                if (type == 'r') {
                    return '-125px'
                }
                if (type == 't') {
                    return '-21px'
                }
            } else if (containerScale == 1.5) {
                if (type == 'r') {
                    return '-121px'
                }
                if (type == 't') {
                    return '-29px'
                }
            } else if (containerScale == 1.6) {
                if (type == 'r') {
                    return '-118px'
                }
                if (type == 't') {
                    return '-36px'
                }
            } else if (containerScale == 1.7) {
                if (type == 'r') {
                    return '-115px'
                }
                if (type == 't') {
                    return '-41px'
                }
            } else if (containerScale == 1.8) {
                if (type == 'r') {
                    return '-113px'
                }
                if (type == 't') {
                    return '-45px'
                }
            } else if (containerScale == 1.9) {
                if (type == 'r') {
                    return '-111px'
                }
                if (type == 't') {
                    return '-51px'
                }
            } else if (containerScale == 2) {
                if (type == 'r') {
                    return '-109px'
                }
                if (type == 't') {
                    return '-54px'
                }
            } else {
                if (type == 'r') {
                    return '-16px'
                }
                if (type == 't') {
                    return '-10px'
                }
            }

        }else if(str == '下拉'){
            if (containerScale == 0.73) {
                if (type == 'r') {
                    return val + 'px'
                }
                if (type == 't') {
                    return val + 'px'
                }
            }else if (containerScale == 0.3) {
                if (type == 'r') {
                    return '-56px'
                }
                if (type == 't') {
                    return '22px'
                }
            }else if (containerScale == 0.4) {
                if (type == 'r') {
                    return '-45px'
                }
                if (type == 't') {
                    return '15px'
                }
            }else if (containerScale == 0.5) {
                if (type == 'r') {
                    return '-38px'
                }
                if (type == 't') {
                    return '10px'
                }
            }else if (containerScale == 0.6) {
                if (type == 'r') {
                    return '-35px'
                }
                if (type == 't') {
                    return '7px'
                }
            }else if (containerScale == 0.7) {
                if (type == 'r') {
                    return '-32px'
                }
                if (type == 't') {
                    return '4px'
                }
            } else if (containerScale == 0.8) {
                if (type == 'r') {
                    return val + 2 + 'px'
                }
                if (type == 't') {
                    return val - 1 + 'px'
                }
            } else if (containerScale == 0.9) {
                if (type == 'r') {
                    return '-29px'
                }
                if (type == 't') {
                    return '2px'
                }
            } else if (containerScale == 1.0) {
                if (type == 'r') {
                    return '-27px'
                }
                if (type == 't') {
                    return '1px'
                }
            } else if (containerScale == 1.1) {
                if (type == 'r') {
                    return '-26px'
                }
                if (type == 't') {
                    return '0px'
                }
            } else if (containerScale == 1.2) {
                if (type == 'r') {
                    return '-25px'
                }
                if (type == 't') {
                    return '-1px'
                }
            } else if (containerScale == 1.3) {
                if (type == 'r') {
                    return '-24px'
                }
                if (type == 't') {
                    return '-2px'
                }
            } else if (containerScale == 1.4) {
                if (type == 'r') {
                    return '-23px'
                }
                if (type == 't') {
                    return '-3px'
                }
            } else if (containerScale == 1.5) {
                if (type == 'r') {
                    return '-22px'
                }
                if (type == 't') {
                    return '-4px'
                }
            } else if (containerScale == 1.6) {
                if (type == 'r') {
                    return '-22px'
                }
                if (type == 't') {
                    return '-4px'
                }
            } else if (containerScale == 1.7) {
                if (type == 'r') {
                    return '-22px'
                }
                if (type == 't') {
                    return '-4px'
                }
            } else if (containerScale == 1.8) {
                if (type == 'r') {
                    return '-21px'
                }
                if (type == 't') {
                    return '-4px'
                }
            } else if (containerScale == 1.9) {
                if (type == 'r') {
                    return '-21px'
                }
                if (type == 't') {
                    return '-4px'
                }
            } else if (containerScale == 2) {
                if (type == 'r') {
                    return '-21px'
                }
                if (type == 't') {
                    return '-4px'
                }
            } else {
                if (type == 'r') {
                    return '-16px'
                }
                if (type == 't') {
                    return '-10px'
                }
            }
        }else if(str == '双菜单'){
            if (containerScale == 0.73) {
                if (type == 'r') {
                    return '-172px'
                }
                if (type == 't') {
                    return '13px'
                }
            }else if (containerScale == 0.3) {
                if (type == 'r') {
                    return '-313px'
                }
                if (type == 't') {
                    return '89px'
                }
            }else if (containerScale == 0.4) {
                if (type == 'r') {
                    return '-253px'
                }
                if (type == 't') {
                    return '58px'
                }
            }else if (containerScale == 0.5) {
                if (type == 'r') {
                    return '-217px'
                }
                if (type == 't') {
                    return '39px'
                }
            }else if (containerScale == 0.6) {
                if (type == 'r') {
                    return '-194px'
                }
                if (type == 't') {
                    return '20px'
                }
            }else if (containerScale == 0.7) {
                if (type == 'r') {
                    return '-176px'
                }
                if (type == 't') {
                    return '13px'
                }
            } else if (containerScale == 0.8) {
                if (type == 'r') {
                    return '-163px'
                }
                if (type == 't') {
                    return '2px'
                }
            } else if (containerScale == 0.9) {
                if (type == 'r') {
                    return '-153px'
                }
                if (type == 't') {
                    return '2px'
                }
            } else if (containerScale == 1.0) {
                if (type == 'r') {
                    return '-144px'
                }
                if (type == 't') {
                    return '-2px'
                }
            } else if (containerScale == 1.1) {
                if (type == 'r') {
                    return '-138px'
                }
                if (type == 't') {
                    return '-6px'
                }
            } else if (containerScale == 1.2) {
                if (type == 'r') {
                    return '-133px'
                }
                if (type == 't') {
                    return '-10px'
                }
            } else if (containerScale == 1.3) {
                if (type == 'r') {
                    return '-128px'
                }
                if (type == 't') {
                    return '-13px'
                }
            } else if (containerScale == 1.4) {
                if (type == 'r') {
                    return '-124px'
                }
                if (type == 't') {
                    return '-15px'
                }
            } else if (containerScale == 1.5) {
                if (type == 'r') {
                    return '-120px'
                }
                if (type == 't') {
                    return '-16px'
                }
            } else if (containerScale == 1.6) {
                if (type == 'r') {
                    return '-118px'
                }
                if (type == 't') {
                    return '-18px'
                }
            } else if (containerScale == 1.7) {
                if (type == 'r') {
                    return '-115px'
                }
                if (type == 't') {
                    return '-18px'
                }
            } else if (containerScale == 1.8) {
                if (type == 'r') {
                    return '-113px'
                }
                if (type == 't') {
                    return '-21px'
                }
            } else if (containerScale == 1.9) {
                if (type == 'r') {
                    return '-111px'
                }
                if (type == 't') {
                    return '-20px'
                }
            } else if (containerScale == 2) {
                if (type == 'r') {
                    return '-109px'
                }
                if (type == 't') {
                    return '-23px'
                }
            } else {
                if (type == 'r') {
                    return '-109px'
                }
                if (type == 't') {
                    return '-23px'
                }
            }
        }else if(str == '列面板'){
            if (containerScale == 0.73) {
                if (type == 'r') {
                    return '53px'
                }
                if (type == 't') {
                    return '111px'
                }
            }else if (containerScale == 0.3) {
                if (type == 'r') {
                    return '349px'
                }
                if (type == 't') {
                    return '429px'
                }
            }else if (containerScale == 0.4) {
                if (type == 'r') {
                    return '227px'
                }
                if (type == 't') {
                    return '296px'
                }
            }else if (containerScale == 0.5) {
                if (type == 'r') {
                    return '149px'
                }
                if (type == 't') {
                    return '216px'
                }
            }else if (containerScale == 0.6) {
                if (type == 'r') {
                    return '99px'
                }
                if (type == 't') {
                    return '168px'
                }
            }else if (containerScale == 0.7) {
                if (type == 'r') {
                    return '64px'
                }
                if (type == 't') {
                    return '129px'
                }
            } else if (containerScale == 0.8) {
                if (type == 'r') {
                    return '36px'
                }
                if (type == 't') {
                    return '87px'
                }
            } else if (containerScale == 0.9) {
                if (type == 'r') {
                    return '15px'
                }
                if (type == 't') {
                    return '65px'
                }
            } else if (containerScale == 1.0) {
                if (type == 'r') {
                    return '-1px'
                }
                if (type == 't') {
                    return '52px'
                }
            } else if (containerScale == 1.1) {
                if (type == 'r') {
                    return '-15px'
                }
                if (type == 't') {
                    return '38px'
                }
            } else if (containerScale == 1.2) {
                if (type == 'r') {
                    return '-26px'
                }
                if (type == 't') {
                    return '21px'
                }
            } else if (containerScale == 1.3) {
                if (type == 'r') {
                    return '-36px'
                }
                if (type == 't') {
                    return '-6px'
                }
            } else if (containerScale == 1.4) {
                if (type == 'r') {
                    return '-44px'
                }
                if (type == 't') {
                    return '-8px'
                }
            } else if (containerScale == 1.5) {
                if (type == 'r') {
                    return '-51px'
                }
                if (type == 't') {
                    return '-19px'
                }
            } else if (containerScale == 1.6) {
                if (type == 'r') {
                    return '-58px'
                }
                if (type == 't') {
                    return '-10px'
                }
            } else if (containerScale == 1.7) {
                if (type == 'r') {
                    return '-63px'
                }
                if (type == 't') {
                    return '-14px'
                }
            } else if (containerScale == 1.8) {
                if (type == 'r') {
                    return '-68px'
                }
                if (type == 't') {
                    return '-17px'
                }
            } else if (containerScale == 1.9) {
                if (type == 'r') {
                    return '-73px'
                }
                if (type == 't') {
                    return '-23px'
                }
            } else if (containerScale == 2) {
                if (type == 'r') {
                    return '-76px'
                }
                if (type == 't') {
                    return '-26px'
                }
            } else {
                if (type == 'r') {
                    return '-109px'
                }
                if (type == 't') {
                    return '-23px'
                }
            }
        }


    }

    return {
        conscale,
        creatGrid,
        creatGridPreview,
    }
}










